import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import { Row, Col } from 'reactstrap';

import './QuestionsArea.scss';

const ns = 'questions-area';

class QuestionsArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'General',
      selected: 0
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    this.props.setParticipantComments(event.target.value);
  }

  render() {
    const { className } = this.state;
    const { id, appointment, textareaRef, hidden, intl, disabled } = this.props;
    const classProps = classNames(ns, className);
    const { participantComments } = appointment;

    return (
      <Row className={classProps} hidden={hidden}>
        <Col xs={12} className="additional-questions-section">
          <textarea
            ref={textareaRef}
            id={`${id}`}
            placeholder={intl.formatMessage({
              id: 'c8.review.additional.comments'
            })}
            value={participantComments}
            onChange={this.onChange}
            className={`${ns}__textarea`}
            disabled={disabled}
          />
        </Col>
      </Row>
    );
  }
}

QuestionsArea.propTypes = {
  appointment: PropTypes.object,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  id: PropTypes.string,
  intl: PropTypes.object.isRequired,
  setParticipantComments: PropTypes.func.isRequired,
  textareaRef: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool
};

QuestionsArea.defaultProps = {
  className: '',
  title: '',
  disabled: false
};

export default QuestionsArea;



// WEBPACK FOOTER //
// ./src/components/atoms/QuestionsArea/QuestionsArea.js